<template>
    <div class="row">
        <div class="col-md-12">
            <card>
                <tabs>
                    <tab-pane label="Speakers">
                        <div
                            v-if="loading"
                            class="col-12 mt-5"
                            v-loading="true"></div>
                        <div v-else>
                            <div class="col-12 d-flex justify-content-end">
                                <router-link :to="{ name: 'speakers-create' }">
                                    <el-button
                                        type="primary"
                                        class="btn btn-primary">
                                            Add
                                    </el-button>
                                </router-link>
                            </div>
                            <el-table :data="$store.state.speakers" stripe border class="header-background">
                                <el-table-column label="Name" prop="name"/>
                                <el-table-column label="Actions">
                                    <template slot-scope="props">
                                        <router-link :to="{ name: 'speakers-edit', params: { speakerId: props.row._id } }">
                                            <el-tooltip content="Edit" placement="top">
                                                <el-button class="btn" title="Edit">
                                                    <fa :icon="['fas', 'pen']"/>
                                                </el-button>
                                            </el-tooltip>
                                        </router-link>
                                        <el-tooltip content="Delete" placement="top">
                                            <el-button
                                                @click="removeSpeaker(props.row._id)"
                                                class="btn btn-danger ml-1"
                                                title="Delete">
                                                    <fa :icon="['fas', 'trash']"/>
                                            </el-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </tab-pane>
                    <tab-pane label="General Settings">
                        <form class="form-horizontal">
                            <!-- NAME -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Name *</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.name"/>
                                    </div>
                                </div>
                            </div>
                            <!-- START DATE -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Start Date *</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-date-picker
                                            v-model="event.startDate"
                                            type="datetime"/>
                                    </div>
                                </div>
                            </div>
                            <!-- END DATE -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">End Date *</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-date-picker
                                            v-model="event.endDate"
                                            type="datetime"/>
                                    </div>
                                </div>
                            </div>
                            <!-- COUNTRY -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Country</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-select v-model="event.country" placeholder="Country">
                                            <el-option
                                                v-for="(country, index) in countries"
                                                :key="`country-${index}`"
                                                :label="country.name"
                                                :value="country.code"/>
                                        </el-select>
                                        <div class="form-text">Select the country, the region and the city where your event will be taking place.</div>
                                    </div>
                                </div>
                            </div>
                            <!-- LOGO -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Logo</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <input
                                            type="file"
                                            id="logo-upload"
                                            @change="uploadLogo"/>
                                        <label for="logo-upload">
                                            <el-button>Choose File</el-button>
                                        </label>
                                        <div v-if="logoProgress !== 100">
                                            <el-progress :percentage="logoProgress"/>
                                        </div>
                                        <div
                                            v-else-if="event.logo && event.logo._id"
                                            class="form-text">
                                                <img :src="baseUrl + event.logo.path" width="100px"/>
                                        </div>
                                        <div
                                            v-else
                                            class="form-text">
                                                Upload a logo to identify your event.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- BANNER -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Banner</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <input
                                            type="file"
                                            id="logo-upload"
                                            @change="uploadBanner"/>
                                        <label for="logo-upload">
                                            <el-button>Choose File</el-button>
                                        </label>
                                        <div v-if="bannerProgress !== 100">
                                            <el-progress :percentage="bannerProgress"/>
                                        </div>
                                        <div
                                            v-else-if="event.banner && event.banner._id"
                                            class="form-text">
                                            <img :src="baseUrl + event.banner.path" width="100px"/>
                                        </div>
                                        <div
                                            v-else
                                            class="form-text">
                                                Select a banner image to identify your event in event calendars and social media
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- LANGUAGE -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Language</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-select v-model="event.language">
                                            <el-option
                                                v-for="(language, index) in languages"
                                                :key="`language-${index}`"
                                                :label="language.name"
                                                :value="language.code"/>
                                        </el-select>
                                        <div class="form-text">Choose language for you event. default texts in the website and mailings will appear in this language.</div>
                                    </div>
                                </div>
                            </div>
                            <!-- WEBSITE -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Website</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.website">
                                            <template slot="prepend">https://</template>
                                        </el-input>
                                        <div class="form-text">Define a url for your event website. please do not use spaces or special characters.</div>
                                    </div>
                                </div>
                            </div>
                            <!-- ADDRESS -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Address</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <gmap-autocomplete
                                            :value="event.address"
                                            @place_changed="setMapPlace"
                                            class="w-100"/>
                                        <div class="form-text">What’s the exact address of your event?</div>
                                    </div>
                                </div>
                            </div>
                            <!-- LOCATION -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Location</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <!-- <el-input/> -->
                                        <div class="form-text">Locate your event in the map.</div>
                                        <gmap-map
                                            @click="selectLocation"
                                            :center="mapOptions.center"
                                            :zoom="7"
                                            :options="mapOptions"
                                            style="width: 100%; height: 300px; margin-top: 10px">
                                                <gmap-marker
                                                    v-if="event.location && event.location.lat && event.location.lng"
                                                    :position="event.location"/>
                                        </gmap-map>
                                    </div>
                                </div>
                            </div>
                            <!-- Description -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Description</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <!--el-input v-model="event.description" type="textarea" rows="10"/-->
                                        <quill-editor v-model="event.description"/>
                                        <div class="form-text">Enter a short description for your event.</div>
                                    </div>
                                </div>
                            </div>
                            <!-- Keywords -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Keywords</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.keywords"/>
                                        <div class="form-text">Enter keywords related to your event to help search engines find them. separate keywords by commas.</div>
                                    </div>
                                </div>
                            </div>
                            <!-- Terms And Conditions -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Terms And Conditions</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <quill-editor v-model="event.termsAndConditions"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Notification Email -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Notification E-Mail</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.notificationEmail" type="email"/>
                                        <div class="form-text">E-Mail address to receive admin notifications.</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable editing of `Activities` under `View Registration` page only by superadmin</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.viewRegActEditAdminOnly"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Send E-Mails -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Send E-Mails</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.sendEmails"/>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Enable Mass Texting/SMS -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable Mass Texting/SMS</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.enableMassTexts"/>
                                    </div>
                                </div>
                            </div>
                            <!-- send email when payment is made -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Send email when payment is made</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.sendEmailsOnPaymentMade"/>
                                    </div>
                                </div>
                            </div>
                            <!-- User Activity Logging to DB -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">User Activity Logging on/off</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.userActivityLog"/>
                                    </div>
                                </div>
                            </div>
                            <!-- User Activity Logging to DB with Data Store -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Save JSON Data using user activity logging</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.userActivityLogWithData"/>
                                    </div>
                                </div>
                            </div>
                            <!-- confirmation number generation -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Custom confirmation number generation</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.customConfirmationNumberGeneration"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="event.customConfirmationNumberGeneration">
                                <label class="col-sm-2 col-form-label">Confirmation number sequence</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.confirmationNumberSequence" type="number" placeholder="Please specified number sequence, Ex-10000"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Check for duplicates</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.checkForDuplicates" />
                                    </div>
                                </div>
                            </div>
                            <!-- Allow Cash Payment -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Allow Cash Payment</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.allowCash" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                             <!-- Verify registrant checked in for event when performing Activty checkin -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Verify registrant checked in for event when performing Activty checkin</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.verifyRegistrantCheckedInForEventWhenPerformingActivtyCheckin" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Allow registrant check in ONLY when FULLY PAID -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Allow registrant check in ONLY when FULLY PAID</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.allowRegistrantCheckInOnlyWhenFullyPaid" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Online Payment Only -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Force Online Payment during Registration</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.onlinePaymentOnly" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Allow Payment Deposit -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Allow Payment Deposit/ Minimum Payment Required</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.allowDeposit" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Allow Payment Deposit -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Do not show Totals in Dwonloable Report</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.hideTotalsInReport" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Deposit Amount -->
                            <div v-if="event.allowDeposit" class="row">
                                <label class="col-sm-2 col-form-label">Deposit Amount</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.depositAmount" type="number" min="0"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Do not show map on Confirmation page -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Do NOT show map on Website & Confirmation page</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.dontShowMapOnConfirmationPage" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- show Edit My Registration -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Show `Edit My Registration`</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.showEditMyRegistration" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Show info during Edit my Registration Request -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Show info during Edit my Registration Request</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.showEditRegistrationRequestInfo" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Edit Registration Request Info -->
                            <div class="row" v-if="event.showEditRegistrationRequestInfo">
                                <label class="col-sm-2 col-form-label">Edit Registration Request Info</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <quill-editor v-model="event.editRegistrationRequestInfo"/>
                                    </div>
                                </div>
                            </div>

                            <!--  Prevent Lesser Total Amount Submission by Registrant during Edit Registration -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Prevent Lesser Total Amount Submission by Registrant during Edit Registration</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.preventLesserAmount" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Allow Registrant To Delete -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Allow Registrant To Delete Their Existing Registrant</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.allowRegistrantToDeleteRegistrant" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- No of mass mail will send in one interval -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">No of mass mail will send in one interval</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.noOfMassMailWillSendInOneInterval" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- confirmation number on badge -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Include confirmation number on badge</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.includeConfirmationNumberOnBadge" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Display code on the badge for activities -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Display code on the badge for activities</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.displayCodeOnBadgeForActivities" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Display QR code on confirmation email & confirmation page -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Display QR code on confirmation email & confirmation page</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.qrOnConfirmationEmailAndConfirmationPage" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Display the activities together with the Registrant names -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Display the activities together with the Registrant names</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.displayActivitiesTogetherWithRegistrantNames" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Hide all payment related info from registrant -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Hide all payment related info from registrant</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.hideAllPaymentInfoFromRegistrant" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Allow Badge Printing For ANY Status -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Allow Badge Printing For ANY Status</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.allowBadgePrintingForAnyStatus" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Enable enableUnsatisfiedMinimumCount -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable Unsatisfied Minimum Count</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.enableUnsatisfiedMinimumCount" class="mt-2"/>
                                    </div>
                                </div>
                            </div>


                            <!-- Enable Payment Info -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable Payment Info</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.enablePaymentInfo" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Payment Info -->
                            <div class="row" v-if="event.enablePaymentInfo">
                                <label class="col-sm-2 col-form-label">Payment Info</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <quill-editor v-model="event.paymentInfo"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Online payment processing fee -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Online Payment Processing Fee</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input
                                            type="number"
                                            min="0"
                                            max="100"
                                            v-model="event.onlinePaymentProcessingFee"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Enable Paypal -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable Paypal</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.enablePaypal" class="mt-2"/>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Enable Zelle -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable Zelle</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.enableZelle" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Zelle Display Order -->
                            <div class="row" v-if="event.enableZelle">
                                <label class="col-sm-2 col-form-label">Zelle Display Order</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.zelleDisplayOrder"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Zelle Payment Provider Name -->
                            <div class="row" v-if="event.enableZelle">
                                <label class="col-sm-2 col-form-label">Payment Provider Name</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.paymentProviderName"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Zelle Description -->
                            <div class="row" v-if="event.enableZelle">
                                <label class="col-sm-2 col-form-label">Zelle Description</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <quill-editor v-model="event.zelleDescription"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Enable Stripe -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable Stripe</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.enableStripe" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Enable Stripe Test Mode -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Enable Stripe Test Mode</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.stripeTestMode" class="mt-2"/>
                                    </div>
                                </div>
                            </div>



                            <!-- Stripe Display Order -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Stripe Display Order</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeDisplayOrder"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Stripe Publishable Key -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Stripe Publishable Key</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripePublishableKey"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Stripe Secret Key -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Stripe Secret Key</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeSecretKey"/>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Stripe Webhook Secret -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Stripe Webhook Secret</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeWebhookSecret"/>
                                    </div>
                                </div>
                            </div>


                            <!-- Stripe Refund Secret -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Stripe Refund Secret</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeRefundSecret"/>
                                    </div>
                                </div>
                            </div>


                            <!-- Test Stripe Publishable Key -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Test Stripe Publishable Key</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripePublishableKeyTest"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Test Stripe Secret Key -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Test Stripe Secret Key</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeSecretKeyTest"/>
                                    </div>
                                </div>
                            </div>

                            <!--Test Stripe Webhook Secret -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Test Stripe Webhook Secret</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeWebhookSecretTest"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Test Stripe Refund Secret -->
                            <div class="row" v-if="event.enableStripe">
                                <label class="col-sm-2 col-form-label">Test Stripe Refund Secret</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeRefundSecretTest"/>
                                    </div>
                                </div>
                            </div>
                           
                            <!-- Paypal Display Order -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Paypal Display Order</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.paypalDisplayOrder"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Paypal Client ID -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Paypal Client ID</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.paypalClientId"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Paypal Sandbox Client ID -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Paypal Sandbox Client ID</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.paypalSandboxClientId"/>
                                    </div>
                                </div>
                            </div>
                            <!-- Paypal Sandbox Mode -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Paypal Sandbox Mode</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.paypalSandboxMode" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- TinyMCE API Key -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">TinyMCE API Key</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.tinyMceApiKey"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Show Type Description In Registration Page -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Show Type Description In Registration Page</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.showTypeDescription" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Prevent External Registrations -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Prevent External Registrations</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.preventExternalRegistrations" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Prevent External Registrations Message -->
                            <div class="row" v-if="event.preventExternalRegistrations">
                                <label class="col-sm-2 col-form-label">Prevent External Registrations Message</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <quill-editor v-model="event.preventExternalRegistrationsMessage" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Prevent External Registrations -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Allow Camera/Scanner Checkin</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.allowScannerCheckin" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Poll Checkpoint Print Jobs -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Poll Checkpoint Print Jobs</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.pollCheckpoints" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Poll Registration Print Jobs -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Poll Registration Print Jobs</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-checkbox v-model="event.pollRegistrations" class="mt-2"/>
                                    </div>
                                </div>
                            </div>

                            <!-- App Currency -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">App Currency</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.appCurrency"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Stripe Currency -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Stripe Currency</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.stripeCurrency"/>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- PayPal Currency -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">PayPal Currency</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.paypalCurrency"/>
                                    </div>
                                </div>
                            </div>

                            <!-- Polling Interval -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Polling Interval (Milliseconds)</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.pollingInterval"/>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Auth Timeout -->
                            <div class="row">
                                <label class="col-sm-2 col-form-label">Auth Timeout (Seconds)</label>
                                <div class="col-sm-10">
                                    <div class="form-group">
                                        <el-input v-model="event.authTimeout"/>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <label class="col-sm-2 col-form-label">Clear Logs</label>
                                <div class="col-sm-10">
                                    <el-button
                                        type="danger"
                                        @click="clearLogsDialog = true"
                                    >
                                        Clear Logs
                                    </el-button>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-sm-2 col-form-label">Delete Event</label>
                                <div class="col-sm-10">
                                    <el-button
                                        type="danger"
                                        @click="deleteEvent"
                                        :loading="deleting">
                                            Delete Event
                                    </el-button>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-sm-2 col-form-label">Migrate Checkins</label>
                                <div class="col-sm-10">
                                    <el-button
                                        type="danger"
                                        @click="migrateChekins"
                                        :loading="migrating">
                                            Migrate
                                    </el-button>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <label class="col-sm-2 col-form-label">Clear Print Jobs</label>
                                <div class="col-sm-10">
                                    <el-button
                                        type="danger"
                                        @click="clearPrintJobsDialog = true"
                                    >
                                        Clear Print Jobs
                                    </el-button>
                                </div>
                            </div>
                        </form>
                        <div class="d-flex justify-content-end">
                            <el-button
                                :loading="saving"
                                class="btn btn-primary"
                                @click="submit()">
                                    Save
                            </el-button>
                        </div>
                    </tab-pane>
                </tabs>
            </card>

            <el-dialog
            title="Clear Logs"
            :visible.sync="clearLogsDialog">
                <el-form>
                    <el-form-item label="Till date">
                        <el-input v-model="tillDate" type="date"/>
                    </el-form-item>
                    <checkbox v-model="deleteLoginLogs" class="text-left">
                        Also delete login logs
                    </checkbox>
                    <!-- <el-form-item label="Also delete login logs">
                    </el-form-item> -->
                </el-form>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="primary"
                            @click="clearLogs"
                            >
                            Clear
                        </el-button>
                    </div>
                </template>
        </el-dialog>
            <el-dialog
            title="Are you sure you want to clear print jobs?"
            :visible.sync="clearPrintJobsDialog">
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="danger"
                            @click="clearPrintJobs"
                            >
                            Clear
                        </el-button>
                    </div>
                </template>
        </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import countries from '@/assets/js/countries'
import languages from '@/assets/js/languages'
import swal from 'sweetalert2'
import { Checkbox } from '@/components/now-ui'
import http from '../http.js'

export default {
    components: {
        Checkbox
    },
    computed: {
        ...mapState([
            'event',
            'baseUrl'
        ])
    },
    data () {
        return {
            countries,
            languages,
            mapOptions: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                center: {
                    lat: 40.1792,
                    lng: 44.4991
                }
            },
            logoProgress: 100,
            bannerProgress: 100,
            logoInterval: null,
            bannerInterval: null,
            loading: false,
            saving: false,
            deleting: false,
            clearLogsDialog: false,
            tillDate: null,
            deleteLoginLogs: null,
            migrating: false,
            deletePrintJobs: null,
            clearPrintJobsDialog: false
        }
    },
    watch: {
        event: {
            deep: true,
            handler: function(){
                console.log("event: ", this.event)
            }
        }
    },
    mounted () {
        this.getSpeakers()
    },
    methods: {
        migrateChekins: async function () {
          this.migrating = true
          try {
            const res = await http.post(`/api/checkins/migrate`, {
                eventId: this.$route.params.eventId
            });
            this.$notify(res.data.message)
          }  catch(e){
            this.$notify({
                type: 'danger',
                message: 'Something error occured',
            })
          }
          this.migrating = false
        },
        getSpeakers: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('getAll', {
                    path: 'speakers',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
            } catch (e) {
                console.log('erorr getting speakers')
            }
            this.loading = false
        },
        uploadLogo: async function (event) {
            this.logoProgress = 1
            this.logoInterval = setInterval(() => {
                if (this.logoProgress < 98) {
                    this.logoProgress += 1
                } else {
                    clearInterval(this.logoInterval)
                    this.logoInterval = null
                }
            }, 100)

            try {
                const response = await this.$store.dispatch('uploadFile', event.target.files[0])
                this.event.logo = response.data.file
            } catch (e) {
                console.log('error uploading logo')
            }

            clearInterval(this.logoInterval)
            this.logoInterval = null
            this.logoProgress = 100
        },
        uploadBanner: async function (event) {
            this.bannerProgress = 1
            this.bannerInterval = setInterval(() => {
                if (this.bannerProgress < 98) {
                    this.bannerProgress += 1
                } else {
                    clearInterval(this.bannerInterval)
                    this.bannerInterval = null
                }
            }, 100)

            try {
                const response = await this.$store.dispatch('uploadFile', event.target.files[0])
                this.event.banner = response.data.file
            } catch (e) {
                console.log('error uploading banner')
            }

            clearInterval(this.bannerInterval)
            this.bannerInterval = null
            this.bannerProgress = 100
        },
        removeSpeaker: async function (id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the speaker?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (confirmed) {
                    this.$store.commit('SET', ['speakers', this.$store.state.speakers.filter(speaker => speaker._id !== id)])
                    this.$store.dispatch('remove', { path: 'speakers', id })
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting speaker')
            }
        },
        submit: async function () {
            this.saving = true
            try {
                await this.$store.dispatch('update', {
                    path: 'events',
                    data: this.event,
                    id: this.$route.params.eventId
                })
                await this.$store.dispatch('get', { path: 'events', key: 'event', id: this.$route.params.eventId })
                this.$notify('Information successfully updated!')
            } catch (e) {
                console.log('error saving settings')
            }
            this.saving = false
        },
        deleteEvent: async function () {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the event ? All information related to event will be deleted!`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (confirmed) {
                    this.deleting = true
                    await this.$store.dispatch('remove', { path: 'events', id: this.$route.params.eventId })
                    this.$router.push({ name: 'events' })
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting speaker')
            }

            this.deleting = false
        },
        selectLocation: function ({ latLng }) {
            let location = {
                lat: latLng.lat(),
                lng: latLng.lng()
            }

            this.mapOptions.center = location
            this.event.location = location
        },
        setMapPlace: function (data) {
            let location = {
                lat: data.geometry.location.lat(),
                lng: data.geometry.location.lng()
            }

            this.mapOptions.center = location
            this.event.location = location
        },
        async clearLogs(){

            if(!this.tillDate){
                return this.$notify('Specify till date')
            }

            if(!this.deleteLoginLogs) this.deleteLoginLogs = false
            
            try {
                await this.$store.dispatch('clearLogs', {
                    eventId: this.event._id,
                    tillDate: this.tillDate,
                    deleteLoginLogs: this.deleteLoginLogs
                })

                this.$notify('Logs cleared')
                
            } catch (error) {
                console.log(error)
                console.log('error clearing logs')
            }
        },
        async clearPrintJobs(){

            this.clearPrintJobsDialog = false
            
            try {
                await http.post('/api/print-jobs/clear', {
                    eventId: this.event._id
                })

                this.$notify('Print jobs cleared')
                
            } catch (error) {
                console.log(error)
                console.log('error clearing print jobs')
            }
        }
    }
}
</script>
